
<div mat-dialog-title>Import Loss Priority Settings<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content>

  <mat-card class="warn block">

    <mat-card-title style="white-space: pre-line;">Your .csv file includes invalid records</mat-card-title>
    <!--        <mat-card-subtitle>The records listed below will not get imported.</mat-card-subtitle>-->
  </mat-card>
  <div style="white-space: pre-line;">The records listed below will not get imported.</div>
  <div style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">
    <table class="import"  width="100%">
      <thead>
        <tr>
          <th style="text-align:left">Entity</th>
          <th style="text-align:left">Error Condition</th>
          <th style="text-align:left">Line Number</th>
        </tr>
      </thead>
      <tbody>
        @for (invalidRecord of lossPriorityDialogData.invalidRecords; track invalidRecord) {
          <tr>
            <td>{{invalidRecord.entity === undefined ? invalidRecord.accountNumber : invalidRecord.entity}}</td>
            <td>{{invalidRecord.errorDesc}}</td>
            <td>{{invalidRecord.lineNumber}}</td>
          </tr>
        }
      </tbody>

    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
  <button id="continueButton" (click)="continue()" class="btn-medium-primary">Continue
  </button>
</mat-dialog-actions>
